import React, { FC } from 'react';
import { DeleteBlockAttachmentError, AddBlockAttachmentError } from '@bechtel/types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalClose,
  Box,
  Text,
  ButtonAppearance,
  ModalSize,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { Trans, t } from '@lingui/macro';
import { FooterButtonStyled } from '@bechtel/client-common';
import { AddRemoveBlockAttachmentErrorProps } from './types';

//TODO: More specific errors needs to be added for different mutation errors.
const getErrorMessage = (error: AddRemoveBlockAttachmentErrorProps['addRemoveBlockAttachmentError']) => {
  if (error instanceof ApolloError)
    return (
      <Trans>
        Network error has occured.Please press the &ldquo;Retry&rdquo; button to fetch the latest data and try again.
      </Trans>
    );
  switch (error) {
    case DeleteBlockAttachmentError.MISSING_REQUIRED_PERMISSION:
    case AddBlockAttachmentError.MISSING_REQUIRED_PERMISSION:
      return <Trans>You have no required permission to add or remove photos.</Trans>;
    case DeleteBlockAttachmentError.NOT_FOUND:
    case DeleteBlockAttachmentError.BLOCKID_NOT_FOUND:
    case AddBlockAttachmentError.NOT_FOUND:
      return <Trans>No block found corresponding to the attachment.</Trans>;
    case AddBlockAttachmentError.EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT:
      return <Trans>Max 3 photos can be uploaded.</Trans>;
    case AddBlockAttachmentError.SERVICE_PROXY_ERROR:
    case DeleteBlockAttachmentError.SERVICE_PROXY_ERROR:
      return <Trans>Downstream service is down. Please try again after sometime.</Trans>;
    default:
      return (
        <Trans>
          An error has occured. Please press the &ldquo;Update&rdquo; button to fetch the latest data and try again.
        </Trans>
      );
  }
};

export const AddRemoveBlockAttachmentError: FC<AddRemoveBlockAttachmentErrorProps> = ({
  addRemoveBlockAttachmentError,
  close,
}) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="qty-config-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Add/Remove Photo Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(addRemoveBlockAttachmentError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
